import SmimeViewState from '../store/schema/SmimeViewState';
import { isFeatureEnabled } from 'owa-feature-flags';

const isSmimeEnabledInViewState = (smimeViewState: SmimeViewState): boolean => {
    if (smimeViewState) {
        const { shouldEncryptMessageAsSmime, shouldSignMessageAsSmime } = smimeViewState;
        return (
            isFeatureEnabled('cmp-smime') &&
            (shouldEncryptMessageAsSmime || shouldSignMessageAsSmime)
        );
    } else {
        return false;
    }
};

export default isSmimeEnabledInViewState;
